// removed by extract-text-webpack-plugin
module.exports = {"AllocationStateSelector":"AllocationStateSelector__AllocationStateSelector__3qOBo","AllocationStateSelectorButtons":"AllocationStateSelector__AllocationStateSelectorButtons__3Lp_6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AllocationStateSelector/AllocationStateSelector.css
// module id = 492
// module chunks = 0